<template lang="pug">
    v-card.width-100-percent(flat)
        v-card-text.pa-0
            ScorecardNewDialog(
                v-if="!artifactsRemovedForCompliance"
                :conference-id="conferenceId"
                :show-snackbar="showSnackbar"
                @create="getScorecards"         
            )

            TableFixedHeader(
                :height="250"
                hide-count
                :is-loading="isLoading"
                :items="scorecards"
                :num-of-sticky-columns="0"
            )
                template(v-slot:th-default) 
                    th.text-left.no-wrap Template
                    th.text-left.no-wrap Assessment
                    th.text-left.no-wrap Score
                    th.text-left.no-wrap Status

                template(v-slot:tr-default="slotProps")
                    td.no-wrap.xs-width
                        router-link(:to="{ name: 'scorecards_show', params: { vid: slotProps.item.vid } }" target="_blank" style="text-decoration: none;")
                            StrLimitTooltipText(:text="getScorecardName(slotProps.item)" :char-limit="25")
                    td.no-wrap.xs-xs-width
                        template(v-if="isValidLlmAssessment(slotProps.item)")
                            span(v-if="slotProps.item.llm_assessment.is_flagged")
                                .by-pulse-banner.flagged-by-pulse-banner.banner-small
                                    | Flagged by Pulse
                            span(v-else)
                                .by-pulse-banner.approved-by-pulse-banner.banner-small
                                    | Approved by Pulse
                        template(v-else)
                            | ---
                    td.no-wrap.xs-xs-width
                        template(v-if="slotProps.item.status === 'pending' || !(slotProps.item.scorecard_template_id > 0)")
                            | ---
                        template(v-else)
                            strong(:class="scoreColorClass(scorePercentage(slotProps.item))")
                                | {{ scorePercentage(slotProps.item).toFixed(2) }}%
                    td.no-wrap.xs-xs-width
                        StatusText(:text="getStatus(slotProps.item.status)")

                template(v-if="!validScorecards && !isLoading" v-slot:table-alert)
                    v-alert(v-if="artifactsRemovedForCompliance" outlined type='warning' dense border='left' style="margin: 10px 0px;")
                        | Pulse scorecards are unavailable for this call because recording consent was not satisfied under two-party consent rules.
                    v-alert(v-else outlined type='info' dense border='left' style="margin: 10px 0px;")
                        | Unable to find any scorecards.

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import ScorecardNewDialog from "@/components/scorecards/new_dialog.vue";
    import StatusText from "@/components/shared/status_text.vue";
    import StrLimitTooltipText from "@/components/shared/str_limit_tooltip_text.vue";
    import TableFixedHeader from "@/components/shared/table_fixed_header.vue";

    // Data
    import { 
        GetScorecards,
    } from '@/data';

    // Helpers
    import { getScorecardScorePercentage, scorecardScoreColorClass, } from "@/helpers/scorecard";

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
                scorecards: [],
            }
        },
        methods: {
            getScorecards() {
                const options = {
                    conference_id: this.conferenceId || 0,
                }
                
                this.isLoading = true;
                GetScorecards(options).then((response) => {
                    if (response?.Data?.scorecards?.length > 0) { 
                        this.scorecards = response.Data.scorecards;
                    }

                    this.isLoading = false;
                });
            },
            getScorecardName(scorecard) {
                if (scorecard?.name?.length > 0) {
                    return scorecard.name;
                }
                if (this.isValidLlmAssessment(scorecard)) {
                    return "Pulse Assessment";
                }

                return null;

            },
            getStatus(status) {
                switch (status) {
                    case 'pending':
                        return 'todo';
                    case 'complete':
                        return 'reviewed';
                    default:
                        return status;
                }
            },
            init() {
                if (this.artifactsRemovedForCompliance) {
                    return;
                }
                
                this.getScorecards();
            },
            isValidLlmAssessment(scorecard) {
                return scorecard?.llm_assessment?.llm_assessment_id > 0 && scorecard.llm_assessment.valid_for_analytics === true && scorecard.llm_assessment.status === 'complete';
            },
            scoreColorClass(score) {
                return scorecardScoreColorClass(score, 100);
            },
            scorePercentage(scorecard) {
                if (!(scorecard.points_available > 0)) {
                    return 0;
                }

                return getScorecardScorePercentage(scorecard.points_scored, scorecard.points_available);
            },
        },
        computed: {
            validScorecards() {
                return this.scorecards?.length > 0;
            }
        },
        props: {
            conferenceId: Number,
            showSnackbar: Function,
            artifactsRemovedForCompliance: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            ScorecardNewDialog,
            TableFixedHeader,
            StatusText,
            StrLimitTooltipText,
        },
        created() {
            this.init();
        },
    });
</script>

<style lang="scss" scoped>
</style>